/// <amd-module name="typeahead/core/userfeedbacktool/ui/AppreciationMessage" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const appreciationHtml: string = `
    <div class="appreciationBox">
        <label id="appreciation_label" class="box-title appreciationText"></label>
        <div class="separator" style="margin-top:32px; width:100%; height:1px;background-color: #c7c7c7"></div>
        <button role="button" type="button" class="userfeedback backToSearch no-outline" id="backToSearchButton"/>
    </div>
`;

export class AppreciationMessage {

    public static getSingleton() {
        if (!this.instance) {
            this.instance = new AppreciationMessage();
        }
        return this.instance;
    }
    private static instance: AppreciationMessage;
    private readonly $appreciationMessage: JQuery;

    private constructor() {
        this.$appreciationMessage = $(appreciationHtml);
        this.$appreciationMessage.children(".appreciationText").text(loc.appreciatingUserMessage);
        this.$appreciationMessage.children(".backToSearch").text(loc.backToSearchMessage);
    }

    public render(domElementId: string): void {
        const $contentDiv = $(document.createElement("div"));
        $contentDiv.append(this.$appreciationMessage);
        const appreciationMessageModal = uitk.modal.create({
            animation: "fade-in-none-out",
            content: $contentDiv,
            focusClose: domElementId,
            footer: false,
            modalId: "appreciationModal",
        });
        const $appreciationModal: JQuery = $("#appreciationModal");

        $appreciationModal.children(".modal-inner").addClass("appreciationModalContainer");
        const $goingToBox: JQuery = $(".autocomplete-dropdown:visible");
        if (!TypeaheadUtils.isWithinMobileBreakpoint() && $goingToBox.length) {
            if ($goingToBox.offset().top  > $(window).scrollTop() + 68) {
                $appreciationModal.find(".modal-inner").css("margin-top",
                    $goingToBox.offset().top - $(window).scrollTop() - 150);
            }
            $appreciationModal.find(".modal-inner").css("margin-left", $goingToBox.offset().left + 5);
        }
        $appreciationModal.find("#modalCloseButton").remove();
        $appreciationModal.find("button.backToSearch").on("click", () => {
            if (domElementId) {
                $("#" + domElementId).attr("data-hasfocus", "true");
            }
            appreciationMessageModal.close();
        });
    }
}
